import {
    SAVE_DATA_OPTIONS_SUCCESS,
    FETCH_DATA_OPTIONS_SUCCESS
  } from "./constants";
  
  import { IRegisterOption, IAction } from "./../../../models";
  
  const initialState: IRegisterOption = {
    total: 0,
    options: [],
    rows: [],
    info: {}
  };
  
  export function reducer(
    state = initialState,
    { type, payload }: IAction
  ): IRegisterOption {
    switch (type) {
      case FETCH_DATA_OPTIONS_SUCCESS:
      case SAVE_DATA_OPTIONS_SUCCESS:
        return {
          ...state,
          ...payload
        }
      default:
        return state;
    }
  }

